export const reviewCount = {
  found_pluralized: ['найден', 'найдено', 'найдено'],
  items: 'отзывы',
  items_pluralized: ['отзыв', 'отзыва', 'отзывов'],
};
